// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".description[data-v-3589df2c]{line-height:28px}.contentList[data-v-3589df2c]{margin:10px 0}", ""]);
// Exports
module.exports = exports;
